import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ManagerIcon from '../../assets/customIcon/manager-icon.svg';
import elfoLogo from '../../assets/elfo_A2P.png';
import avatar from '../../assets/elfo_icon_new.svg';
import perkesoLogo from '../../assets/logo-perkeso.png';
import { getRequest } from '../../helpers/apiHandler';
import { formatWithoutCurrency } from '../../helpers/helperFunction';
import { onLogout, setLoginSuccess } from '../../store/actions/reduxAction';
import { ProfilePictureCircle } from '../Admin/AdminLogos';
import ConfirmationModal from '../shared/apiLifeCycle/ConfirmationModal';

const baseUrl = process.env.PUBLIC_URL;
const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const ManagerTopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { access_token, available_balance, name, verified, currency, role } = useSelector(
    (state) => state.auth.user
  );
  const { reload_top_bar } = useSelector((state) => state.topbar);
  const [showModalFlag, setShowModalFlag] = useState(false);
  const verifiedColor = verified ? '#00abe0' : '#b5b6b7';

  const handleRemove = () => {
    dispatch(onLogout());
    localStorage.clear();
    navigate('/login');
  };

  const check_if_logged_in = () => {
    if (!access_token) return navigate('/login');
    if (role !== 'manager') return navigate('/dashboard');

    const data = { headers: { Authorization: access_token.token } };
    getRequest('/user/me', data, (res) => {
      if (res.success) {
        dispatch(setLoginSuccess(res));

        // Moving the forced navigate by role to here, because of the balance wont be updated if we put it up there
        // Add checks if the current user is already has logged in then don't redirect...
        if (role === 'manager' && !location.pathname.includes('/manager/')) {
          return navigate('/manager/dashboard');
        }
      }
      if (res.error) {
        return navigate('/login');
      }
    });
  };

  const handleSMSPriceListClick = () => {
    navigate('/manager/dashboard/sms-price-list', { replace: false });
  };

  const handleTopupClick = () => {
    navigate('/manager/dashboard/payment/buy-credits', { replace: false });
  };

  const renderCredits = (revenue) => {
    const formattedRevenue = white_label_perkeso
      ? formatWithoutCurrency(revenue || 0, 0)
      : formatWithoutCurrency(revenue || 0, 2);
    const revenueClass = parseFloat(revenue) > 0 ? 'text-success' : 'text-error';

    return (
      <div className="trial-credits">
        <span>CREDIT BALANCE</span>
        <span className={revenueClass}>
          {white_label_perkeso ? `${formattedRevenue}` : `${currency.symbol} ${formattedRevenue}`}
        </span>
      </div>
    );
  };

  useEffect(() => {
    check_if_logged_in();
  }, [reload_top_bar]);

  return (
    <div className="topbar">
      <div className="top-bar-component-container pb-1">
        <nav className="navbar navbar-expand navbar-light pt-0 pb-0">
          <Link className={white_label_perkeso ? "navbar-brand-p" : "navbar-brand"} to={`${baseUrl}/manager/dashboard`}>
            <img
              className="elfoLogo"
              alt="background-vector"
              src={white_label_perkeso ? perkesoLogo : elfoLogo}
            />
          </Link>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              <li className="nav-item account-status">
                {!white_label_perkeso && (
                  <>
                    <Button
                      variant="ghost"
                      onClick={handleSMSPriceListClick}
                      style={{ minWidth: 120 }}
                    >
                      SMS Pricing
                    </Button>
                    <Button variant="primary" onClick={handleTopupClick} style={{ minWidth: 120 }}>
                      Top Up
                    </Button>
                  </>
                )}
                {renderCredits(available_balance)}
              </li>
              <li className="nav-item dropdown">
                <div className="user-profile nav-link pr-0">
                  <ProfilePictureCircle />
                  <img src={avatar} className={'with-avatar'} alt="Avatar" />
                </div>
                <div
                  className="nav-link dropdown-toggle user-profile-dropdown"
                  href="#"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="username">
                    <span>{name}</span>
                    <img alt="..." src={ManagerIcon} />
                    <i className="fas fa-chevron-down ml-2" />
                  </div>
                </div>
                <div
                  className="dropdown-menu name-initials-dropdown"
                  aria-labelledby="navbarDropdown"
                >
                  <Link className="dropdown-item" to="/manager/dashboard/account/personal-info">
                    Account Settings
                  </Link>
                {!white_label_perkeso && (
                  <Link className="dropdown-item" to="/manager/dashboard/account/billing-log">
                    Account Billing
                  </Link>
                )}
                  <div className="dropdown-divider" />
                  <button className="dropdown-item dropdown-item-logout" onClick={handleRemove}>
                    <i className="fas fa-sign-out-alt mr-2" />
                    Logout
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <ConfirmationModal
        show={showModalFlag}
        close={() => setShowModalFlag(false)}
        onClick={handleRemove}
        message="Are you sure you want to logout?"
        btns={{
          leftBtn: 'Cancel',
          rightBtn: 'Confirm',
        }}
      />
    </div>
  );
};

export default ManagerTopBar;
